"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ANGULARJS_SERVICE_UPGRADE_TOKENS = exports.AngularJsServiceUpgradeType = void 0;
const core_1 = require("@angular/core");
var AngularJsServiceUpgradeType;
(function (AngularJsServiceUpgradeType) {
    AngularJsServiceUpgradeType["SMART_SERVICE_DELIVERY"] = "SmartServiceDelivery";
    AngularJsServiceUpgradeType["ROOT_SCOPE"] = "$rootScope";
})(AngularJsServiceUpgradeType || (exports.AngularJsServiceUpgradeType = AngularJsServiceUpgradeType = {}));
exports.ANGULARJS_SERVICE_UPGRADE_TOKENS = {
    ROOT_SCOPE_TOKEN: new core_1.InjectionToken(AngularJsServiceUpgradeType.ROOT_SCOPE),
    SMART_SERVICE_DELIVERY_TOKEN: new core_1.InjectionToken(AngularJsServiceUpgradeType.SMART_SERVICE_DELIVERY)
};
